export enum SpecialPrizesPresetsActionTypes {
    GET_SUBSIDIARIES = "[App Action][Presets] GET SUBSIDIARIES",
    GET_SUBSIDIARIES_SUCCESS = "[App Action][Presets] GET SUBSIDIARIES SUCCESS",
    GET_SUBSIDIARIES_FAIL = "[App Action][Presets] GET SUBSIDIARIES FAIL",
    GET_PRESETS = "[App Action][Presets] GET PRESETS",
    GET_PRESETS_SUCCESS = "[App Action][Presets] GET PRESETS SUCCESS",
    GET_PRESETS_FAIL = "[App Action][Presets] GET PRESETS FAIL",
    GET_PRESET = "[App Action][Presets] GET PRESET",
    GET_PRESET_SUCCESS = "[App Action][Presets] GET PRESET SUCCESS",
    GET_PRESET_FAIL = "[App Action][Presets] GET PRESET FAIL",
    UPDATE_PRESET = "[App Action][Presets] UPDATE PRESET",
    CLEAR_PRESET = "[App Action][Presets] CLEAR PRESET",
    CLEAR_SUBMIT_PRESET = "[App Action][Presets] CLEAR SUBMIT PRESET",
    ADD_PRESET = "[App Action][Presets] ADD PRESET",
    ADD_PRESET_SUCCESS = "[App Action][Presets] ADD PRESET SUCCESS",
    ADD_PRESET_FAIL = "[App Action][Presets] ADD PRESET FAIL",
    EDIT_PRESET = "[App Action][Presets] EDIT PRESET",
    EDIT_PRESET_SUCCESS = "[App Action][Presets] EDIT PRESET SUCCESS",
    EDIT_PRESET_FAIL = "[App Action][Presets] EDIT PRESET FAIL",
    TOGGLE_PRESET_ACTIVE = "[App Action][Presets] TOGGLE PRESET ACTIVE",
    TOGGLE_PRESET_ACTIVE_SUCCESS = "[App Action][Presets] TOGGLE PRESET ACTIVE SUCCESS",
    TOGGLE_PRESET_ACTIVE_FAIL = "[App Action][Presets] TOGGLE PRESET ACTIVE FAIL",
    TOGGLE_CERTIFIED_PRESET = "[App Action][Presets] TOGGLE CERTIFIED PRESET",
    TOGGLE_CERTIFIED_PRESET_SUCCESS = "[App Action][Presets] TOGGLE CERTIFIED PRESET SUCCESS",
    TOGGLE_CERTIFIED_PRESET_FAIL = "[App Action][Presets] TOGGLE CERTIFIED PRESET FAIL"
}
